import React from 'react';
import { Route } from 'react-router-dom';
import TicketsPage from './TicketsPage';

export const routes = [
    <Route key="1" path="/properties/:propertyId/tickets">
        <TicketsPage />
    </Route>,
];
